// src-crsld/components/footer/footer.component.js
import { FooterController } from '@common/components/footer/footer.component';
import template from './footer.tpl.html'; // Comment this out for test
import './footer.scss';

class CrsldFooterController extends FooterController {

  async $onInit() {

    await super.$onInit(); // This populates this.page
    this.year = this.DayjsService.now().format('YYYY');
  }

}

// --- Component Definition ---
class CrsldFooterComponent {
  constructor() {
    this.template = template;
    this.controller = CrsldFooterController;
  }
}

export default angular
  .module('mrsfooter.component', [])
  .component('mrsfooter', new CrsldFooterComponent())
  .name;